
import { mapActions, mapState } from "vuex";
export default {
  name: "ProfileDropdown",
  props: {
    isAuth: Boolean,
  },
  computed: {
    ...mapState("user", ["currentUser"]),
    ...mapState("notification", ["totalNotification"]),
    profile() {
      const { first_name, first_name_kh, last_name, last_name_kh } =
        this.currentUser || {};
      return {
        photo: this.currentUser?.photo || "/images/default-user.png",
        username: this.$isKm()
          ? [first_name_kh, last_name_kh].join(" ")
          : [first_name, last_name].join(" "),
        email: this.currentUser?.email,
      };
    },
    menuItems() {
      return [
        {
          title: this.$t("notification"),
          href: "/user/profile/notification",
          icon: "mdi-bell-ring",
        },
        {
          title: this.$t("connection"),
          href: "/user/profile/connection",
          icon: "mdi-account-group",
        },
        {
          title: this.$t("startup"),
          href: "/user/profile/startup",
          icon: "mdi-rocket-launch",
        },
        {
          title: this.$t("mentor"),
          href: "/user/profile/mentor",
          icon: "mdi-human-male-board",
        },
        {
          title: this.$t("investor"),
          href: "/user/profile/investor",
          icon: "mdi-account-tie",
        },
        {
          title: this.$t("eso.title"),
          href: "/user/profile/eso",
          icon: "mdi-handshake",
        },
      ];
    },
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    login() {
      this.$emit("login");
    },
    async logoutUser() {
      this.$swal
        .fire({
          text: this.$t("dialog.question.logout"),
          type: "info",
          showCancelButton: true,
          reverseButtons: true,
          width: 400,
          confirmButtonColor: "#d33",
          cancelButtonText: this.$t("dialog.cancel"),
          confirmButtonText: this.$t("dialog.logout"),
        })
        .then((result) => {
          if (!result.value) return;
          this.logout().then((response) => {
            window.location.reload();
          });
        });
    },
  },
};
